import { render, staticRenderFns } from "./SOMenu.vue?vue&type=template&id=0079755b&scoped=true"
import script from "./SOMenu.vue?vue&type=script&lang=ts"
export * from "./SOMenu.vue?vue&type=script&lang=ts"
import style0 from "./SOMenu.vue?vue&type=style&index=0&id=0079755b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0079755b",
  null
  
)

export default component.exports